import { c as _c } from "react/compiler-runtime";
import type { CSSProperties } from "react";
import { Typography } from "@repo/ui/aops-components/typography";
import { PanelCornerDots } from "@/app/components/PanelCornerDots";
import styles from "./ProgramSubjectNav.module.css";
export type ProgramSubjectNavImage = {
  src: string;
  alt: string;
};
export type ProgramSubjectNavItemData = {
  key: string;
  title: string;
  subtitle?: string | null;
  image?: ProgramSubjectNavImage | null;
};
type ProgramSubjectNavItemProps = {
  item: ProgramSubjectNavItemData;
  isActive: boolean;
  href: string;
  onSelect: (key: string) => void;
};
export function ProgramSubjectNavItem(t0) {
  const $ = _c(25);
  const {
    item,
    isActive,
    href,
    onSelect
  } = t0;
  let t1;
  if ($[0] !== item.subtitle) {
    t1 = item.subtitle?.trim();
    $[0] = item.subtitle;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const subtitle = t1;
  const t2 = isActive ? `${styles.link} ${styles.linkActive}` : styles.link;
  const t3 = isActive ? "true" : undefined;
  let t4;
  if ($[2] !== item.key || $[3] !== onSelect) {
    t4 = event => {
      event.preventDefault();
      onSelect(item.key);
    };
    $[2] = item.key;
    $[3] = onSelect;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className={styles.decor}><PanelCornerDots className={styles.decorRow} dotClassName={styles.decorDot} /></span>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== item.image) {
    t6 = item.image && <span className={styles.icon} style={{
      "--icon-url": `url(${item.image.src})`
    } as CSSProperties} aria-hidden={true} />;
    $[6] = item.image;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== item.title) {
    t7 = <Typography as="span" variant="buttonLg" className={styles.label}>{item.title}</Typography>;
    $[8] = item.title;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== subtitle) {
    t8 = subtitle && <Typography as="span" variant="tag" className={styles.subtitle}>{subtitle}</Typography>;
    $[10] = subtitle;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t7 || $[13] !== t8) {
    t9 = <span className={styles.text}>{t7}{t8}</span>;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t6 || $[16] !== t9) {
    t10 = <span className={styles.row}>{t6}{t9}</span>;
    $[15] = t6;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <span className={styles.decor}><PanelCornerDots className={styles.decorRow} dotClassName={styles.decorDot} /></span>;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== href || $[20] !== t10 || $[21] !== t2 || $[22] !== t3 || $[23] !== t4) {
    t12 = <li className={styles.item}><a href={href} className={t2} aria-current={t3} onClick={t4}>{t5}{t10}{t11}</a></li>;
    $[19] = href;
    $[20] = t10;
    $[21] = t2;
    $[22] = t3;
    $[23] = t4;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  return t12;
}